/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../../../common";
import type {
  Fwen1155,
  Fwen1155Interface,
} from "../../../../../../contracts/submodules/fwen1155/contracts/fwen/Fwen1155";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "royaltyAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ArrayLengthMismatch",
    type: "error",
  },
  {
    inputs: [],
    name: "BurnningInactive",
    type: "error",
  },
  {
    inputs: [],
    name: "MetadataFrozen",
    type: "error",
  },
  {
    inputs: [],
    name: "NonExistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "RoyaltyPercentageExceed",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "burnBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "burningActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "metadataFrozen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "mintBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "minters",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "maxSupplies",
        type: "uint256[]",
      },
    ],
    name: "setMaxSupplies",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "royaltyReceiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyPercentage",
        type: "uint256",
      },
    ],
    name: "setRoyaltyInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "flag",
        type: "uint256",
      },
    ],
    name: "toggleFlag",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "minter",
        type: "address",
      },
      {
        internalType: "bool",
        name: "valid",
        type: "bool",
      },
    ],
    name: "updateMinter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type Fwen1155ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: Fwen1155ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Fwen1155__factory extends ContractFactory {
  constructor(...args: Fwen1155ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    royaltyAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Fwen1155> {
    return super.deploy(royaltyAddress, overrides || {}) as Promise<Fwen1155>;
  }
  override getDeployTransaction(
    royaltyAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(royaltyAddress, overrides || {});
  }
  override attach(address: string): Fwen1155 {
    return super.attach(address) as Fwen1155;
  }
  override connect(signer: Signer): Fwen1155__factory {
    return super.connect(signer) as Fwen1155__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): Fwen1155Interface {
    return new utils.Interface(_abi) as Fwen1155Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Fwen1155 {
    return new Contract(address, _abi, signerOrProvider) as Fwen1155;
  }
}
